// Değişen ayarları tespit et (genel ayarlar için)
export const getChangedSettings = (originalSettings, newSettings) => {
  const changedSettings = {};

  Object.keys(newSettings).forEach((key) => {
    // Sadece value değeri değişen ayarları al
    if (newSettings[key].value !== originalSettings[key].value) {
      changedSettings[key] = {
        ...originalSettings[key], // Orijinal ayarın diğer özelliklerini koru
        value: newSettings[key].value, // Yeni değeri kullan
      };
    }
  });

  return changedSettings;
};

// Değişen göz ayarlarını tespit et
export const getChangedPotSettings = (
  originalSettings,
  newSettings,
  activePotIndex
) => {
  const changedSettings = {};

  newSettings.pots.forEach((newPot) => {
    Object.keys(newPot).forEach((key) => {
      if (newPot[key].index === activePotIndex) {
        originalSettings.pots.forEach((originalPot) => {
          Object.keys(originalPot).forEach((originalKey) => {
            if (
              originalKey === key &&
              originalPot[originalKey].index === activePotIndex &&
              originalPot[originalKey].value !== newPot[originalKey].value &&
              changedSettings[key] === undefined
            ) {
              changedSettings[key] = {
                ...originalPot[originalKey],
                value: newPot[key].value,
              };
            }
          });
        });
      }
    });
  });

  return changedSettings;
};

// Değişen ayarları tespit et (component içinde kullanılan versiyon)
export const getChangedSettingsForComponent = (
  deviceSettings,
  tempSettings
) => {
  if (!deviceSettings || !tempSettings) return {};

  const changedSettings = {};
  Object.keys(tempSettings).forEach((key) => {
    if (tempSettings[key] && deviceSettings[key]) {
      const originalValue = deviceSettings[key].value;
      const currentValue = tempSettings[key].value;
      if (originalValue !== currentValue) {
        changedSettings[key] = {
          original: originalValue,
          current: currentValue,
          label: deviceSettings[key].label,
        };
      }
    }
  });

  return changedSettings;
};

// Göz ayarları için değişiklikleri tespit et (component içinde kullanılan versiyon)
export const getChangedPotSettingsForComponent = (
  deviceSettings,
  tempSettings,
  activePotIndex
) => {
  if (!deviceSettings || !tempSettings || !tempSettings.pots) return {};

  const changedSettings = {};
  tempSettings.pots.forEach((pot, potIndex) => {
    Object.keys(pot).forEach((key) => {
      if (pot[key] && typeof pot[key].index === "number") {
        const settingIndex = pot[key].index;
        const originalPot = deviceSettings.pots?.[potIndex];
        if (
          originalPot &&
          originalPot[key] &&
          originalPot[key].index === settingIndex
        ) {
          const originalValue = originalPot[key].value;
          const currentValue = pot[key].value;
          if (originalValue !== currentValue) {
            const settingKey = `${key}_${settingIndex}`;
            changedSettings[settingKey] = {
              original: originalValue,
              current: currentValue,
              label: originalPot[key].label,
            };
          }
        }
      }
    });
  });

  return changedSettings;
};
